import { useGlobalContext } from "../context/AuthContext";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";
import {
  GET_FAVORITE,
  CREATE_FAVORITE,
} from "../../services/graphql/queriesMutations";
import { useMutation, useQuery } from "@apollo/client";

interface Props {
  editId: number;
}

const FavComponent = ({ editId }: Props) => {
  const { user } = useGlobalContext();
  const userId = user?.id;

  const { data, loading } = useQuery(GET_FAVORITE, {
    variables: { userId, editId },
    skip: !user,
  });

  const [createFavorite] = useMutation(CREATE_FAVORITE, {
    refetchQueries: [{ query: GET_FAVORITE, variables: { userId, editId } }],
  });

  const favoriteId = data?.favorite?.id;

  const handleClick = async () => {
    if (!user) return;
    try {
      await createFavorite({
        variables: {
          fav: {
            editId,
          },
        },
      });
    } catch (error) {
      console.error("Error adding favorite:", error);
    }
  };

  return (
    <button
      type="button"
      className={`gist-circle-control ${favoriteId ? "is-active" : ""}`}
      onClick={handleClick}
      disabled={loading}
      title="Favorite"
      aria-label="Favorite"
    >
      {favoriteId ? <MdFavorite /> : <MdFavoriteBorder />}
    </button>
  );
};

export default FavComponent;
